import {ReactNode, createContext, useContext, useState} from 'react';

export interface AuthTokenContextType {
  token?: string;
  setToken: (token: string | undefined) => void;
  shopifyCustomerToken?: string;
  setShopifyCustomerToken: (token: string | undefined) => void;
}
export const AuthTokenContext = createContext<AuthTokenContextType>(
  undefined as unknown as AuthTokenContextType,
);

/**
 * Context provider that provides access to auth tokens from out of server-accessible cookies
 * @param param0
 * @returns
 */
export function AuthTokenProvider({
  initialToken,
  initialShopifyCustomerToken,
  children,
}: {
  initialToken?: string;
  initialShopifyCustomerToken?: string;
  children: ReactNode;
}) {
  const [token, setToken] = useState<string | undefined>(initialToken);
  const [shopifyCustomerToken, setShopifyCustomerToken] = useState<
    string | undefined
  >(initialShopifyCustomerToken);

  return (
    <AuthTokenContext.Provider
      value={{token, setToken, shopifyCustomerToken, setShopifyCustomerToken}}
    >
      {children}
    </AuthTokenContext.Provider>
  );
}

export const useAuthTokenContext = (): AuthTokenContextType =>
  useContext(AuthTokenContext);
